import { Navigate, Outlet, useLocation } from "react-router-dom";
import { RequireTermsAcceptance } from "@/components/common/RequireTermsAcceptance";
import { useAuth } from "@/contexts/AuthContext";
import { needsTermsAcceptance } from "@/lib/terms-and-conditions";

export function ProtectedRoute() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-900 to-slate-800 text-slate-200">
        Loading...
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

  const pendingTerms = needsTermsAcceptance(user);

  return (
    <div className="relative min-h-screen">
      <RequireTermsAcceptance />
      {pendingTerms ? null : <Outlet />}
    </div>
  );
}
